import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { api } from '@/lib/api';
import { Crest } from '@/components/Brand';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function VerifyCertificate() {
  const { certificate_number } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/verify/${certificate_number}`).then(({ data }) => setData(data)).finally(() => setLoading(false));
  }, [certificate_number]);

  return (
    <div className="min-h-screen bg-trjlight flex items-center justify-center p-6" data-testid="verify-page">
      <div className="max-w-lg w-full bg-white border border-slate-200 rounded-2xl p-10 text-center">
        <Crest size="lg" className="mx-auto" />
        <h1 className="font-display font-semibold text-2xl text-navy mt-5">Certificate Verification</h1>
        {loading ? (
          <div className="mt-8 h-10 w-10 mx-auto rounded-full border-2 border-navy/20 border-t-navy animate-spin" />
        ) : data?.valid ? (
          <div className="mt-8">
            <CheckCircle2 className="h-12 w-12 text-trjgreen mx-auto" />
            <div className="font-display font-semibold text-trjgreen mt-3">Verified</div>
            <div className="mt-6 text-left space-y-2 bg-trjlight rounded-md p-5">
              <Row k="Certificate #" v={<span className="font-mono text-gold">{data.certificate_number}</span>} />
              <Row k="Student" v={data.student_name} />
              <Row k="Program" v={data.course_title} />
              <Row k="Issued" v={new Date(data.issued_at).toLocaleDateString()} />
            </div>
          </div>
        ) : (
          <div className="mt-8">
            <XCircle className="h-12 w-12 text-red-500 mx-auto" />
            <div className="font-display font-semibold text-red-600 mt-3">Not Verified</div>
            <p className="text-sm text-slate-600 mt-2">This certificate number is invalid, revoked, or not found.</p>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ k, v }) {
  return (
    <div className="flex justify-between gap-3 text-sm">
      <div className="text-slate-500">{k}</div>
      <div className="text-navy font-semibold">{v}</div>
    </div>
  );
}
